export default "__VITE_ASSET__BNu4yWNN__"